import { render, staticRenderFns } from "./Recoveries.vue?vue&type=template&id=e656da20&"
import script from "./Recoveries.vue?vue&type=script&lang=js&"
export * from "./Recoveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports